<script>
export default {
    props: ['start', 'end', 'modifier', 'products'],
    data() {
        return {
            form: new SparkForm({
                start_date: this.start,
                end_date: this.end,
                modifier_date: null,
                modifier: 0,
                modifier_type: 0,
            }),
        };
    },
    methods: {
        setModifier(newVal) {
            this.form.modifier = _.get(newVal, 'modifier', 0);
            this.form.modifier_type = _.get(newVal, 'modifier_type', 0);
            this.form.modifier_date = _.get(newVal, 'modifier_date', this.start);
        },
        removeModifier() {
            this.form.modifier = 0;
            this.saveModifier();
        },
        saveModifier() {
            const _this = this;

            swalc('Are you sure?', function (confirmed) {
                if (confirmed) {
                    Spark.post('/api/price-modifiers', _this.form).then((response) => {
                        _this.$noty.success('Dynamic Pricing Saved');
                        Bus.$emit('priceModifierSaved');
                    });
                }
            });
        },
        hide() {
            Bus.$emit('popperDoClose');
            Bus.$emit('hidePriceModifierField');
        },
        productValue(product) {
            if (product.expired) return 0;
            if (product.product_type === 'promo_bundle') return product.price * product.units_posted_remaining;

            return _.round(product.base_price + product.base_price * (this.form.modifier / 100)) * product.units_posted_remaining;
        },
    },
    computed: {
        adjustedValue() {
            const self = this;
            return _.sumBy(this.products, (product) => {
                return self.productValue(product);
            });
        },
        singleDate() {
            return moment(this.start).isSame(this.end, 'day');
        },
        scheduleDate() {
            return _.has(this.modifier, 'schedule_date.data.start_date') ? moment(_.get(this.modifier, 'schedule_date.data.start_date')) : null;
        },
    },
    watch: {
        modifier: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.setModifier(newVal);
            },
        },
    },
};
</script>
